module.exports = __webpack_public_path__ + "img/livetalk.ff7ca05b.png";